
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/profiles",
      function () {
        return require("private-next-pages/customer-studio/profiles.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/profiles"])
      });
    }
  